<template>
  <div class="Background">

    <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        Wowza 서버 관리
      </h2>

      <div class="link_location">
        설정관리 <v-icon small class="mdi mdi-chevron-right" />
        시스템설정 <v-icon small class="mdi mdi-chevron-right" />
        <a href="/admin/Encoding-Server">Wowza 서버 관리 등록</a>
      </div>
    </div>

    <v-card class="pa-5" elevation="0">

      <v-row class="mb-5">
        <v-col>

          <h4 class="mb-2">서비스 타입</h4>

          <v-row>
            <v-col class="mr-3" @click="serviceType = 'VOD'">
              <v-card class="service_box" link elevation="0">
                <div class="service_box_contents">
                  <div class="icon_box">
                    <v-icon large class="mdi mdi-video-outline" color="#007bff" />
                  </div>

                  <div class="service_box_txt">
                    <h3 class="mb-1">VOD</h3>
                    <p>인코딩, 에셋관리, 썸네일 지정, 플레이리스트, 배포 등 <br>한 번에 관리 가능한 CMS 서비스 </p>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col @click="serviceType = 'LIVE'">
              <v-card class="service_box_live" link elevation="0">
                <div class="service_box_contents">
                  <div class="icon_box">
                    <v-icon large class="mdi mdi-access-point" color="#ffbb29" />
                  </div>

                  <div class="service_box_txt service_box_txt_live">
                    <h3 class="mb-1">LIVE</h3>
                    <p>인코딩, 에셋관리, 썸네일 지정, 플레이리스트, 배포 등 <br>한 번에 관리 가능한 CMS 서비스 </p>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>

        <v-col class="mr-3">
          <h4 class="mb-2" style="color:black;">이름</h4>
          <v-form ref="form" v-model="valid" lazy-validation>
            <FormInput v-model="name" :rules="nameRule" ref="nameInput" :counter="10" placeholder="포트" />
          </v-form>
        </v-col>

        <v-col class="mr-3">
          <h4 class="mb-2" style="color:black;">아이피</h4>
          <v-form ref="form" v-model="valid" lazy-validation>
            <FormInput v-model="ip" ref="ipInput" placeholder="아이피" />
          </v-form>
        </v-col>

        <v-col>
          <h4 class="mb-2" style="color:black;">포트</h4>
          <v-form ref="form" v-model="valid" lazy-validation>
            <FormInput v-model="port" ref="portInput" id="myInput" placeholder="포트" />
          </v-form>
        </v-col>

      </v-row>


    </v-card>

    <v-row justify="end" class="bg-purple mt-3 mr-0">
      <v-col v-for="count in 1" :key="count" cols="auto">
        <TextButton buttonText="취소" @click="cancel" class="mr-2" />
        <TextButton buttonText="등록" @click="addServer" isPrimary />
      </v-col>
    </v-row>

  </div>
</template>

<script>
import FormInput from '@/components/ui/form/FormInput.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import WowzaServerApi from "@/api/wowzaserver/WowzaServerApi";

export default {
  components: {
    FormInput,
    TextButton,
  },
  data() {
    return {
      sOptions: [
        { label: 'VOD', value: 'VOD' },
        { label: 'LIVE', value: 'LIVE' },
      ],
      name: '',
      ip: '',
      port: '',
      valid: true,
      serviceType: null,
      nameRule: [
        v => !!v || 'Name is required',
        v => /^[a-zA-Z][a-zA-Z0-9]*$/.test(v) || 'Must start with a letter and can use letters and numbers',
        v => v && v.length >= 2 && v.length <= 50 || 'Name must be between 2 and 50 characters',
      ],
      ipRule: [
        v => !!v || "IP Address is required",
        v =>
          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
            v
          ) || "IP Address is invalid",
      ],
      portRule: [
        (v) => !!v || "Port is required",
        (v) => /^\d+$/.test(v) || "Port must be a number",
        (v) => v >= 0 && v <= 65535 || "Port must be between 0 and 65535",
      ],
    }
  },
  methods: {
    cancel() {
      this.$router.push('/wowza/wowzaservers_list');
    },
    async addServer() {
      const data = {
        name: this.name,
        ip: this.ip,
        port: this.port,
        type: this.serviceType
      }
      const response = await WowzaServerApi.addApi(data);
      if (response.status === 201) {
        this.$router.push('/wowza/wowzaservers_list');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.service_box {
  text-align: center;
  padding: 20px;
  background: #f7fbff;
}

.service_box:hover {
  background: #f7fbff;
}

.service_box:active {
  background: #ebf5ff;
}

.service_box .service_box_contents {
  display: flex;
  height: 100%;
  text-align: left;
}

.service_box .service_box_txt p {
  margin-bottom: 0px;
  font-size: 14px;
  color: #888;
}

.service_box .icon_box {
  width: 70px;
  height: 70px;
  background: #e9f3ff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 20px;
}

.service_box_live {
  text-align: center;
  padding: 20px;
  background: #fffaef;
}

.service_box_live:hover {
  background: #fff6e3;
}

.service_box_live:active {
  background: #fff0ca;
}

.service_box_live .service_box_contents {
  display: flex;
  height: 100%;
  text-align: left;
}

.service_box_live .service_box_txt p {
  margin-bottom: 0px;
  font-size: 14px;
  color: #888;
}

.service_box_live .icon_box {
  width: 70px;
  height: 70px;
  background: #fff2d2;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 20px;
}
</style>